<h3 class="mt-3" i18n>Search results</h3>

<div class="table-responsive-lg">
    <table class="table table-hover">
        <thead>
            <tr>
                <th class="w-1-rem"></th>
                <th i18n>Name</th>
                <th i18n>Country</th>
                <th i18n>Dates</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let adsCampaign of adsCampaigns">
                <td class="align-middle">
                    <span *ngIf="adsCampaign.status == 'active'" title="Active" i18n-title class="text-success" style="font-size: 1.2rem;">●</span>
                    <span *ngIf="adsCampaign.status == 'inactive'" title="Inactive" i18n-title class="text-danger" style="font-size: 1.2rem;">●</span>
                </td>
                <td class="align-middle">
                    <a [routerLink]="['/campaigns', adsCampaign.id]">{{ adsCampaign.name }}</a>
                </td>
                <td class="align-middle">{{ adsCampaign.organization.country }}</td>
                <td class="align-middle">
                    <span *ngIf="adsCampaign.start_date">{{ adsCampaign.start_date | date: 'shortDate' }}</span>
                    <span *ngIf="!adsCampaign.start_date && adsCampaign.end_date" i18n>Not defined</span>
                    <span>&nbsp;-&nbsp;</span>
                    <span *ngIf="adsCampaign.end_date">{{ adsCampaign.end_date | date: 'shortDate' }}</span>
                    <span *ngIf="!adsCampaign.end_date" i18n>Not defined</span>    
                </td>
                <td class="align-middle text-end">
                    <a [routerLink]="['/campaigns', adsCampaign.id]" class="btn btn-primary btn-sm" i18n>Edit</a>&nbsp;
                    <button type="button" class="btn btn-danger btn-sm" (click)="delete(adsCampaign.id)" i18n>Delete</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>